module.exports = __webpack_public_path__ + "static/media/13.523c164d.jpg";